import React, { useState } from 'react';
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';
import PropsType from 'prop-types';
import { useHistory } from 'react-router-dom';
import { LogOut, Key, MessageCircle, ChevronDown } from 'react-feather';
import { useSelector, useDispatch } from 'react-redux';
import { resetUserSession } from '@Lib/slices/userSlice';
import { sidebarActive, setSideBar } from '@Lib/slices/uiSlice';
import axiosService from '@Lib/axiosService';
import ChangePasswordModal from './ChangePasswordModal';
import { getCurrentSiteBranding } from '@Lib/siteBranding';

export default function UserDropdown() {
  const [changePasswordModal, setChangePasswordModal] = useState(false);

  const toggleChangePasswordModal = () => setChangePasswordModal((prevState) => !prevState);

  const history = useHistory();
  const dispatch = useDispatch();
  const handleLogout = () => {
    localStorage.removeItem(process.env.TOKEN);
    dispatch(resetUserSession());
    dispatch(setSideBar([]));
    dispatch(sidebarActive(null));
    history.push('/login');
  };

  const handleOpenZaloOmni = async () => {
    try {
      const response = await axiosService.get(`${process.env.URL}/sso/zalo-omni-token`);
      const { redirect_url } = response.data;
      window.open(redirect_url, '_blank');
    } catch (error) {
      console.error('Không thể mở Zalo Omni:', error);
      alert('Không thể kết nối Zalo Omni. Vui lòng thử lại.');
    }
  };

  const userInfo = useSelector((state) => state.user.info);
  const projectActive = useSelector((state) => state.user.projectActive);

  const renderRoles = () => {
    if (!userInfo) return null;
    if (userInfo.is_super_admin) return 'Super admin';

    const projectRoles = userInfo.roles_by_project?.[projectActive?.id] || [];
    if (projectRoles.length > 0) return projectRoles.join(', ');

    return 'Thành viên';
  };

  return (
    <>
      <UncontrolledDropdown tag="div" className="dropdown-user nav-item">
        {userInfo && (
          <DropdownToggle
            className="nav-link dropdown-user-link p-0"
            onClick={(e) => e.preventDefault()}
            nav
            style={{ color: '#333' }}
          >
            <div className="d-flex align-items-center">
              <div className="position-relative mr-1">
                <div
                  className="d-flex align-items-center justify-content-center font-weight-bold"
                  style={{ width: '36px', height: '36px', borderRadius: '50%', backgroundColor: '#ffedd5', color: '#ff9800', fontSize: '14px' }}
                >
                  {userInfo?.name.substring(0, 2).toUpperCase()}
                </div>
                <span className="position-absolute rounded-circle bg-success" style={{ width: '10px', height: '10px', bottom: '0', right: '0', border: '2px solid white' }}></span>
              </div>
              <div className="user-info d-none d-md-flex flex-column align-items-start justify-content-center text-left mr-50">
                <span className="user-name font-weight-bolder mb-0" style={{ color: '#171725', fontSize: '14px', lineHeight: '1.2' }}>{userInfo.name.length > 20 ? `${userInfo.name.substring(0, 18)}...` : userInfo.name}</span>
                <span className="user-status text-muted mb-0" style={{ fontSize: '11px', marginTop: '2px' }}>
                  {userInfo.email || getCurrentSiteBranding().name}
                </span>
              </div>
              <ChevronDown size={14} className="d-none d-md-block" color="#92929d" />
            </div>
          </DropdownToggle>
        )}
        <DropdownMenu right>
          <DropdownItem className="w-100" onClick={() => toggleChangePasswordModal()}>
            <Key size={14} className="mr-75" />
            <span className="align-middle">Đổi mật khẩu</span>
          </DropdownItem>
          <DropdownItem className="w-100" onClick={() => handleLogout()}>
            <LogOut size={14} className="mr-75" />
            <span className="align-middle text-danger">Đăng xuất</span>
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
      <ChangePasswordModal isOpen={changePasswordModal} toggle={toggleChangePasswordModal} />
    </>
  );
}

UserDropdown.propTypes = {
  user: PropsType.object,
};
